module.exports = __webpack_public_path__ + "static/img/pcTitle.50814e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcTitle.png
// module id = tC5B
// module chunks = 1